
var form = $('#payment-form');
var stripe;

function checkCardElement(){
  
  // Create a Stripe client
  // stripe = Stripe('pk_test_RmolgTRvpl5Kb9TxsAr6RVwA');
  stripe = Stripe('pk_live_3BJ505ymmXqavG71089a89I0');

  // Create an instance of Elements
  var lang = $('html').attr('lang');
  var elements = stripe.elements({locale:lang});

  // Custom styling can be passed to options when creating an Element.
  // (Note that this demo uses a wider set of styles than the guide below.)
  var style = {
    base: {
      color: '#32325d',
      fontFamily: 'Lato,Helvetica,Arial,sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '14px',
      lineHeight: '17px',
      '::placeholder': {
        color: '#B8BECC'
      }
    },
    invalid: {
      color: '#CC253E',
      iconColor: '#CC253E'
    }
  };

  // Create an instance of the card Element
  var card = elements.create('card', {style: style});

  // Add an instance of the card Element into the `card-element` <div>
  card.mount('#card-element');

  // Handle real-time validation errors from the card Element.
  card.addEventListener('change', function(event) {
    var displayError = $('card-errors');
    if (event.error) {
      displayError.textContent = event.error.message;
    } else {
      displayError.textContent = '';
    }
  });

  // Handle form submission
  form.on('submit', function(event) {
    event.preventDefault();

    // Reset errors notifications
    $('#card-errors, .form__notifications .error, .form__notifications .success').text('');

    stripe.createPaymentMethod(
      'card',
      card
    ).then(function(result) {

      if (result.error) {
        // Show error in payment form
        $('#card-errors').text(result.error.message);

      } else {

        // Set data
        var data = form.serialize();
        data[csrfTokenName] = csrfTokenValue;
        data += '&payment_method_id='+result.paymentMethod.id;
        
        // Send paymentMethod.id to server
				$.ajax({
				  type: 'POST',
				  url: 'actions/stripe/payment/savePayment',
				  dataType: 'json',
				  data: data,
		      beforeSend: function() { 
		        // Disable submit button
		        form.find('input[type="submit"]').prop('disabled', true);
		      },
				  complete: function(response){
				  	handleServerResponse(response);
	  	      // Enable submit button
	  	      form.find('input[type="submit"]').prop('disabled', false);
				  }
				});

      }
    });

  });

}



function handleServerResponse(response) {
	// console.log('handleServerResponse');
	// console.log(response);

	if (response.responseJSON.status == 'error' || response.responseJSON.paymentIntent.status == 'error') {
		// console.log('error');
		// Show error in payment form
		var errorMessage = form.find($('input[name="errorMessage"]')).val();
		errorNotifications(errorMessage, response);

	} else if (response.responseJSON.paymentIntent.status == 'requires_action') {
		// console.log('requires_action');
		// Show stripe popup
	  handleAction(response);

	} else { // response.status == 'success'
		// console.log('success');
		// The card action has been handled
		successNotifications();
	}

}

function handleAction(response) {
	
  stripe.handleCardPayment( // Use stripe.handleCardPayment for automatic validation. Use stripe.handleCardAction for manual validation
    response.responseJSON.paymentIntent.payment_intent_client_secret
  ).then(function(result) {

  	// console.log('handleCardPayment');
  	// console.log(result);

    if (result.error) {
      // Show error in payment form
      var errorMessage = '';
      if (result.error.message.length > 0) {
      	errorMessage = result.error.message;
      } else {
      	errorMessage = form.find($('input[name="errorMessage"]')).val();
      }
      errorNotifications(errorMessage, result);

    } else {
      // The card action has been handled
      successNotifications();
    }

  });
}


function successNotifications(){
	var successMessage = form.find($('input[name="successMessage"]')).val();
	form.delay(400).fadeOut();
	// Display notifications
	$('.form__notifications .success').text(successMessage);
	$('.form__notifications').delay(800).fadeIn();

	// Scroll to form notifications
	scrollToNotifications();
}

function errorNotifications(message, response){
	// Display notifications
	$('.form__notifications .error').text(message);
	$('.form__notifications').fadeIn();

	// Scroll to form notifications
	scrollToNotifications();
	
	// Display error in form
	if (response.responseJSON.error) {
		$.each(response.responseJSON.error, function(key, value){
		  // Display errors
		  $('.field--'+key).addClass('error').find('.errors p').fadeIn();
		  
		  // Update errors
		  $('.field--'+key+' input, .field--'+key+' textarea, .field--'+key+' select').on('change',function(){
		    $('.field--'+key).removeClass('error').find('.errors p').fadeOut();
		  });
		});		
	}
}


function scrollToNotifications(){
	setTimeout(function(){
		$('html, body').animate({
			scrollTop: $('.form__notifications').offset().top - 50
		}, 'slow');
	},1000);
}